export default __webpack_public_path__ + "static/media/linkedin.5f8f48b5.svg";